<template>
  <div>
    <el-tabs v-model="tabValue" @tab-click="switchTabs">
      <el-tab-pane label="进行中的" name="activityInstanceList">
        <el-table
          :data="activityList"
          border
          size="small"
          style="width: 1551px"
        >
          <el-table-column prop="zoneId" label="分区" align="center" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.zoneId == 0" style="">全区</span>
              <span v-else style="">{{ scope.row.zoneId }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="confId"
            label="配置ID"
            align="center"
            width="100"
          >
          </el-table-column>

          <el-table-column prop="key" label="活动key" align="center" width="120" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="type" label="活动类型" align="center" width="100">
          </el-table-column>

          <el-table-column prop="name" label="简称" align="center" width="200" show-overflow-tooltip>
          </el-table-column>

          <el-table-column
            prop="startAt"
            label="开始时间"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{ ms2ymdhm(Number(scope.row.startAt)) }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="endAt"
            label="结束时间"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{ ms2ymdhm(Number(scope.row.endAt)) }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="playStartAt"
            label="玩法开始时间"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{ ms2ymdhm(Number(scope.row.playStartAt)) }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="playEndAt"
            label="玩法结束时间"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{ ms2ymdhm(Number(scope.row.playEndAt)) }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="isOpen"
            label="活动进行中"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.isOpen" style="color: red">否</span>
              <span v-if="scope.row.isOpen" style="color: green">是</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="isSettle"
            label="玩法已结算"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.isSettle" style="color: red">否</span>
              <span v-if="scope.row.isSettle" style="color: green">是</span>
            </template>
          </el-table-column>

          <el-table-column label="内容" align="center" width="150">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.context != 'null' && scope.row.context != '{}'"
                placement="right"
                trigger="hover"
                width="600"
              >
                <div style="margin-top: 5px">
                  <el-input
                    type="textarea"
                    rows="15"
                    :value="string2yaml(scope.row.context)"
                    readonly
                    placeholder=""
                  >
                  </el-input>
                </div>

                <el-button slot="reference" size="small" icon="el-icon-view"
                  >查看</el-button
                >
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button
                type="primary"
                round
                size="mini"
                @click="openSettingActivityDialog(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="下一轮设置" name="activitySwitchList">
        <div>
          <el-button
            style="margin-bottom: 10px"
            type="primary"
            icon="el-icon-plus"
            @click="openSettingActivitySwitchDialog(null, true)"
            >添加设置</el-button
          >
        </div>
        <el-table
          :data="activitySwitchList"
          border
          size="small"
          style="width: 701px"
        >
          <el-table-column prop="key" label="活动" align="center" width="100">
          </el-table-column>

          <el-table-column
            prop="status"
            label="状态"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" style="color: red">
                <span v-if="Number(scope.row.deadline) == 0"> 永久禁止 </span>
                <span v-else> 等待自动解禁 </span>
              </span>
              <span v-if="scope.row.status != 1" style="color: green"
                >允许启动</span
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="deadline"
            label="自动解禁时间"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">{{
                Number(scope.row.deadline) > 0
                  ? ms2ymdhm(Number(scope.row.deadline))
                  : null
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            width="150"
          >
          </el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button
                type="danger"
                round
                size="mini"
                @click="delActivitySwitch(scope.row)"
                >删除</el-button
              >
              <el-button
                type="primary"
                round
                size="mini"
                @click="openSettingActivitySwitchDialog(scope.row, false)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="活动配置" name="活动配置">
        <ActivityTemplatePage v-if="tabValue == '活动配置'" />
      </el-tab-pane>
    </el-tabs>

    <!-- 线上活动实例框 -->
    <SettingActivityDialog
      v-if="shouldSettingActivityDialogVisible"
      @close="onSettingActivityDialogClosed()"
      :value="valueForSettingActivityDialog"
    ></SettingActivityDialog>

    <!-- 活动开关弹出框 -->
    <SettingActivitySwitchDialog
      v-if="shouldSettingActivitySwitchDialogVisible"
      @close="onSettingActivitySwitchDialogClosed()"
      :value="valueForSettingActivitySwitchDialog"
    ></SettingActivitySwitchDialog>

    <!-- 活动配置弹出框 -->
    <ActivityConfigDialog
      v-if="shouldActivityConfigDialogVisible"
      @close="onActivityConfigDialogClosed()"
      :value="valueForActivityConfigDialog"
    ></ActivityConfigDialog>
  </div>
</template>
  
  <script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const yaml = require("js-yaml");

import SettingActivityDialog from "./SettingActivityDialog";
import SettingActivitySwitchDialog from "./SettingActivitySwitchDialog";
import ActivityConfigDialog from "./ActivityConfigDialog";
import ActivityTemplatePage from "./ActivityTemplatePage";

export default {
  data() {
    return {
      tabValue: "activityInstanceList",
      shouldSettingActivityDialogVisible: false, // 编辑线上活动弹出框是否应该显示出来
      valueForSettingActivityDialog: null, // 要传递给线上活动弹出框的数据
      shouldSettingActivitySwitchDialogVisible: false, // 编辑活动开关弹出框是否应该显示出来
      valueForSettingActivitySwitchDialog: null, // 要传递给活动开关弹出框的数据
      shouldActivityConfigDialogVisible: false, // 编辑活动开关弹出框是否应该显示出来
      valueForActivityConfigDialog: null, // 要传递给活动开关弹出框的数据
      activityList: [], // 列表里展示的数据
      activitySwitchList: [], // 活动开关列表
    };
  },

  created() {
    this.loadActivityList();
  },

  components: {
    SettingActivityDialog,
    SettingActivitySwitchDialog,
    ActivityConfigDialog,
    ActivityTemplatePage,
  },

  methods: {
    /**
     * 切换tab
     */
    async switchTabs(tab, event) {
      switch (tab.name) {
        case "activityInstanceList": {
          this.loadActivityList();
          break;
        }
        case "activitySwitchList": {
          this.loadActivitySwitchList();
          break;
        }
      }
    },
    /**
     * 拉取活动实例集合
     */
    async loadActivityList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAllActivitiesInActive`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.activityList = listInResponse;
    },

    /**
     * 拉取活动开关集合
     */
    async loadActivitySwitchList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getActivitySwitch`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.activitySwitchList = listInResponse;
    },

    /**
     * 删除活动开关
     */
    async delActivitySwitch(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除开关“${entry.key}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/delActivitySwitch`,
            {
              key: entry.key,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });
      } catch (e) {}
      // 移除掉被删除的元素
      for (let i = 0; i < this.activitySwitchList.length; i++) {
        if (this.activitySwitchList[i].key == entry.key) {
          this.activitySwitchList.splice(i, 1);
          break;
        }
      }
    },

    /**
     * 打开编辑活动实例对话框
     */
    async openSettingActivityDialog(entry) {
      this.shouldSettingActivityDialogVisible = true;
      this.valueForSettingActivityDialog = {
        info: entry,
      };
    },

    /**
     * 编辑活动实例对话框关闭了
     */
    async onSettingActivityDialogClosed() {
      this.shouldSettingActivityDialogVisible = false;
      // 重新拉取线上活动集合
      return this.loadActivityList();
    },

    /**
     * 打开编辑活动开关对话框
     */
    async openSettingActivitySwitchDialog(entry, isCreated) {
      this.shouldSettingActivitySwitchDialogVisible = true;
      this.valueForSettingActivitySwitchDialog = {
        info: entry,
        isCreated: isCreated,
      };
    },

    /**
     * 编辑活动开关对话框关闭了
     */
    async onSettingActivitySwitchDialogClosed() {
      this.shouldSettingActivitySwitchDialogVisible = false;
      // 重新拉取活动开关集合
      return this.loadActivitySwitchList();
    },

    /**
     * 打开查看活动配置对话框
     */
    async openActivityConfigDialog(entry) {
      this.shouldActivityConfigDialogVisible = true;
      this.valueForActivityConfigDialog = {
        info: entry,
      };
    },

    /**
     * 查看活动配置对话框关闭了
     */
    async onActivityConfigDialogClosed() {
      this.shouldActivityConfigDialogVisible = false;
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    string2yaml(obj) {
      let yamlStr;
      yaml.loadAll(obj, function (doc) {
        yamlStr = yaml.dump(doc, {
          styles: {
            "!!null": "canonical",
          },
          sortKeys: true,
        });
      });
      return yamlStr;
    },
    formatCode(obj) {
      return JSON.stringify(obj, null, "    ");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

  